module.exports = __webpack_public_path__ + "img/005曲明.82afeaf8.png";